<div class="px-4 py-6 border border-neutral-3 rounded-lg">
  <div class="text-lg font-medium mx-4 mb-5">
    Locatie
  </div>
  @if (srcset$|async; as srcset) {
    <div class="relative">
      <img [srcset]="srcset" class="w-full rounded-lg mb-6" alt="Object op kaart">
      <img src="/assets/icons/marker-projects.svg" alt="Punaise" width="33" height="44" class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
    </div>
  }
  <div class="mx-4">
    <div class="text-lg font-medium mb-1">
      <app-copy-to-clipboard [value]="city">{{ city }}</app-copy-to-clipboard>
    </div>
    <app-copy-to-clipboard [value]="address">{{ address }}</app-copy-to-clipboard>
  </div>
</div>
